
import { FaWhatsapp } from "react-icons/fa";

const Hero = () => {
    const desktopBg = "/images/home/servicio_banner.jpg";
    const mobileBg = ("/images/home/banner2.jpg");

    return (
        <section className="relative h-full md:h-screen p-8 bg-[#1e293b] text-white">
            {/* Fondo para desktop */}
            <div
                className="hidden md:block absolute inset-0 bg-no-repeat bg-cover bg-right-bottom"
                style={{ backgroundImage: `url(${desktopBg})` }}
            ></div>

            {/* Fondo para mobile */}
            <div
                className="block md:hidden absolute inset-0 bg-no-repeat bg-cover bg-center"
                style={{ backgroundImage: `url(${mobileBg})` }}
            ></div>

            <div className="absolute inset-0 bg-slate-900/50 "></div>

            <div className="relative z-10 mx-auto py-20 flex flex-col justify-center items-center">
                <h1 className="text-4xl md:text-7xl mx-2 font-bold my-6 bg-gradient-to-r from-white to-purple-300 bg-clip-text text-transparent">
                    NetmaxPlay
                </h1>
                <p className="text-xl md:text-2xl text-center py-8 text-white max-w-3xl mx-auto">
                    Conectamos tu mundo. Protegemos tu espacio.
                </p>
                <p className="text-lg mb-12 text-white text-center max-w-2xl mx-auto">
                    Soluciones tecnológicas integrales para internet satelital, seguridad y
                    monitoreo profesional
                </p>
                <a
                    href="https://wa.me/5493571458075"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-[#581c87] h-12 hover:bg-purple-800 text-base md:text-lg w-fit text-center text-white px-6 py-3 rounded-full flex items-center gap-2 transition"
                >
                    <FaWhatsapp />
                    Contáctanos
                </a>
            </div>
        </section>
    );
};

export default Hero;
